var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "close_svg__b",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#close_svg__a)",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#close_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.85,
    d: "M0 0h16v16H0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "close_svg__a",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#close_svg__c",
    transform: "scale(.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAO5JREFUWAntlg0KwjAMhaen8maexnN4vJk3DNiu+R8OpYFS2iTfS6MrXZZpswP7Dtxo60njTuOyd4d3wAALTLBNQ+D6Hg+aK0UgFwzmgW0aquUEzNkienGwwDZtlBgtosyoACq5TXcyoExOI9ovIsBIbK+jrj1gT4wqYjk1Ac1ncUN+SejzO698tq5iRkUccWe4xDlIKiJ6V2y8K1N/ZZZOzz9Dqgvew4/EIfiVP6Ekjn3N5z2cGucR8MSoIpIzAo7ESnrNfgaYyWlEeVEBVXI3/TKAKCXG6U8yPByPulj6ToBt2unPcrPCGfBXHXgB78etD0lxsakAAAAASUVORK5CYII=",
    id: "close_svg__c",
    width: 32,
    height: 32
  }))));
};
export default SvgClose;